import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'What’s the difference between UI and UX design?',
    answer: 'UI (User Interface) focuses on the look and feel of your digital product, while UX (User Experience) ensures the interaction is intuitive, efficient, and user-friendly.',
  },
  {
    question: 'What tools do you use for UI/UX design?',
    answer: 'We use industry-standard tools like Figma, Adobe XD, Sketch, InVision, and Balsamiq for wireframes, prototypes, and design mockups.',
  },
  {
    question: 'Do you provide design prototypes or just static visuals?',
    answer: 'Yes, we provide fully interactive prototypes so you can experience user flow before development begins.',
  },
  {
    question: 'Can you redesign an existing website or app UI?',
    answer: 'Absolutely. We audit existing designs and improve them for better usability, performance, and aesthetics.',
  },
  {
    question: 'How do you ensure your designs are user-friendly?',
    answer: 'We perform UX research, competitor analysis, A/B testing, and usability testing to refine designs based on real user behavior.',
  },
  {
    question: 'Do you also handle responsive and mobile-first design?',
    answer: 'Yes, every UI/UX project we take on is designed to be fully responsive and optimized for all screen sizes and devices.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
